import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, switchMap } from 'rxjs';
import { UserService } from '@services/user/user.service';
import { NavigationService } from '@services/navigation/navigation.service';
import { Building } from '@app/shared/models/building.interface';
import { takeUntil } from 'rxjs/operators';
import { AdmFilterComponent } from '@app/driver-metrics/timeseries/adm-filter/adm-filter.component';
import { DriverMetricsTableComponent } from '@app/driver-metrics/timeseries/driver-metrics-table/driver-metrics-table.component';
import { AdmFilterService } from '@app/driver-metrics/timeseries/adm-filter.service';
import { BuildingService } from '@services/building/building.service';

@Component({
  selector: 'app-driver-metrics-timeseries',
  imports: [DriverMetricsTableComponent, AdmFilterComponent],
  templateUrl: './driver-metrics-timeseries.component.html',
  styleUrl: './driver-metrics-timeseries.component.scss'
})
export class DriverMetricsTimeseriesComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  building: Building;

  constructor(
    private readonly userService: UserService,
    private readonly navService: NavigationService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly admFilterService: AdmFilterService,
    private readonly buildingService: BuildingService
  ) {}

  ngOnInit(): void {
    this.buildingService.currentBuilding$.pipe(takeUntil(this.destroy$)).subscribe((building) => {
      if (this.admFilterService.filterCriteriaValue?.buildingId !== building?.id) {
        this.admFilterService.resetFilterCriteria();
      }
    });

    this.activatedRoute.parent.params
      .pipe(
        takeUntil(this.destroy$),
        switchMap((params) => this.userService.getBuilding(params.buildingId))
      )
      .subscribe((building) => {
        this.building = building;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
